import React, { Component } from 'react';
import styles from './LabeledTextarea.module.scss';

interface Props {
  label?: string;
  placeholder?: string;
  onChange?: (value: string) => void;
  value?: string;
}

interface State {
  focused: boolean;
  value: string;
}

class LabeledTextarea extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      focused: false,
      value: ''
    };
  }

  render() {
    const { focused, value: stateValue } = this.state;
    const textareaStyles = [styles.textarea];
    focused && textareaStyles.push(styles.textareaFocused);

    const {
      label = 'Description',
      placeholder = 'Type description...',
      onChange,
      value: propsValue
    } = this.props;

    return (
      <div className={styles.container}>
        <label htmlFor=''>{label}</label>
        <textarea
          className={textareaStyles.join(' ')}
          placeholder={placeholder}
          onFocus={() => this.setState({ focused: true })}
          onBlur={() => this.setState({ focused: false })}
          onChange={({ target: { value } }) => onChange ? onChange(value) : this.setState({ value })}
          value={propsValue || stateValue}
        />
      </div>
    );
  }
}

export default LabeledTextarea;
